export const VK_ACCESS_TOKEN_GET_SUCCESS = 'VK_ACCESS_TOKEN_GET_SUCCESS';
export const VK_ACCESS_TOKEN_GET_FAIL = 'VK_ACCESS_TOKEN_GET_FAIL';
export const VK_SET_APP_ID = 'VK_SET_APP_ID';
